import { firstValueFrom, map } from 'rxjs';
import {
  AggregationKey,
  Aggregations,
  DefaultAggregations,
  LERNFORMEN,
  LernformKey
} from '../../../../model/aggregations';
import { FacettenOptionInfo } from '../../facetten-option-info';
import { FacettenService } from '../../facetten.service';
import { LernformUrlService } from './lernformurl.service';

export const getEnumValueByKey = (
  aggregations: DefaultAggregations | LERNFORMEN,
  key: string
): LERNFORMEN | null => {
  const aggregation = Object.entries(aggregations).find(([agg]) => agg === key);
  return aggregation?.[1];
};

/**
 * Abstraktionsebene der einzelnen LernformFacetten
 * Fasst die Services der einzelnen LernformFacetten (Gruppierungen aus dem Backend)
 * zusammen um sie im LernformService gesammelt nutzen zu können
 */
export abstract class LernformFacettenService extends FacettenService {
  protected constructor(
    lernformUrlService: LernformUrlService,
    public aggregationDetailName: LernformKey,
    orderedOptions: FacettenOptionInfo[]
  ) {
    super(lernformUrlService, AggregationKey.Lernformen, orderedOptions);
  }

  /**
   * Überschreibt das getAggregations des FacettenServices,
   * um auf die genesteten Facetten der innerhalb der Lernformaggregation zugreifen zu können
   */
  override getAggregation(aggregations: Aggregations) {
    return getEnumValueByKey(
      getEnumValueByKey(aggregations, this.aggregationName)!,
      this.aggregationDetailName
    );
  }

  // Aktualisiert den ausgewählten Filter
  override updateSelectedIds(selectedIds: string[]): void {
    firstValueFrom(this.selectedIds$).then((alreadySelectedIds) => {
      firstValueFrom(this.getSelectItems$().pipe(map((item) => item.map(({ key }) => key)))).then(
        (lernformIds) => {
          const alreadySelectedFromOtherLernformenIds = alreadySelectedIds.filter(
            (id: string) => !lernformIds.includes(id)
          );
          const allIds = alreadySelectedFromOtherLernformenIds.concat(selectedIds);
          const allUniqueIds = [...new Set(allIds)];
          this.facettenUrlService.updateSelection(allUniqueIds);
        }
      );
    });
  }
}
